import React from "react";
import { useSelector, RootStateOrAny } from "react-redux";
import IndividualNameVersionsTable from "./IndividualNameVersionsTable";
import IndividualInfoVersionsTable from "./IndividualInfoVersionsTable";
import IndividualSubscribersTable from "./IndividualSubscribersTable";
import IndividualDocumentsTable from "./IndividualDocumentsTable";
import IndividualEmailsTable from "./IndividualEmailsTable";
import IndividualAddressTable from "./IndividualAddressTable";
import IndividualPhonesTable from "./IndividualPhonesTable";
import { checkIsLoaded } from "../../lib/utils/checkLoadingStatus";

const IndividualAccountInfo = ({ changeExiteIdOpenedModal }) => {
  const { accountStatusesLoading, accountTypesLoading } = useSelector(
    (state: RootStateOrAny) => state.dicts
  );
  return (
    <>
      {checkIsLoaded(accountStatusesLoading, accountTypesLoading) && (
        <>
          <IndividualNameVersionsTable />
          <IndividualInfoVersionsTable />
          <IndividualSubscribersTable changeExiteIdOpenedModal={changeExiteIdOpenedModal} />
          <IndividualDocumentsTable />
          <IndividualPhonesTable />
          <IndividualEmailsTable />
          <h4 style={{ marginTop: "45px" }}>Адрес</h4>
          <IndividualAddressTable addressType="legalAddress" />
          <IndividualAddressTable addressType="actualAddress" />
        </>
      )}
    </>
  );
};

export default IndividualAccountInfo;
